import { Box, Grid, IconButton, Typography } from '@mui/joy';
import type { FieldArrayConfig, FieldArrayRenderProps } from 'formik/dist/FieldArray';
import classNames from 'classnames';
import { FieldArray } from 'formik';
import React from 'react';

import { AddIcon } from '@/shared/icons/Icons';

type Props = Omit<FieldArrayConfig, 'render'> & {
  title: string;
  onAdd: (helpers: FieldArrayRenderProps) => void;
  renderInput: (props: FieldArrayRenderProps) => React.ReactNode;
  renderFooter?: (props: FieldArrayRenderProps) => React.ReactNode;
  maxHeight?: string;
  className?: string;
  subtitle?: string;
};

const FieldArrayContainer: React.FC<Props> = ({
  onAdd,
  renderInput,
  renderFooter,
  title,
  subtitle,
  maxHeight = 'max-h-[130px]',
  className,
  ...props
}) => (
  <Box
    sx={(theme) => ({
      borderColor: theme.palette.neutral.outlinedBorder,
      borderRadius: '0.5rem',
      borderWidth: 1,
      boxShadow: theme.shadow.xs,
      marginBottom: '1.75rem',
      marginTop: '1rem',
      paddingBottom: '0.75rem',
      paddingTop: '0.5rem',
      paddingX: '0.25rem',
      position: 'relative',
    })}
    className={className}
  >
    <FieldArray
      {...props}
      render={(helpers) => (
        <>
          <div className="flex items-center justify-between pl-2 pr-1">
            <div>
              <Typography className="font-semibold" level="title-sm" textColor="text.secondary">
                {title}
              </Typography>
              {subtitle && <Typography className="text-xs text-gray-500">{subtitle}</Typography>}
            </div>
            <IconButton onClick={() => onAdd(helpers)} size="sm">
              <AddIcon />
            </IconButton>
          </div>
          <Grid
            mt={1}
            container
            spacing={1}
            className={classNames('overflow-y-auto px-2', maxHeight)}
          >
            {renderInput(helpers)}
          </Grid>
          {renderFooter && renderFooter(helpers)}
        </>
      )}
    />
  </Box>
);

export default FieldArrayContainer;
